import React, { Fragment } from "react";
import { Link } from "./link";

const Breadcrumbs = ({ pathItems }) => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="breadcrumbs">
            {pathItems?.map((item, index) => (
              <Fragment key={index}>
                {item.url ? (
                  <Link className="breadcrumbs__link" to={item.url}>
                    {item.label}
                  </Link>
                ) : (
                  <span className="breadcrumbs__link">{item.label}</span>
                )}
                {index < pathItems.length - 1 && <span className="breadcrumbs__separator"></span>}
              </Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumbs;
